<h1 class="accent-background-element">Transfer Patient to another Clinic</h1>

<mat-dialog-content>

  <h3>Patient ID:&nbsp;<span class="not-bold">{{currentPatient?.patientId}}</span></h3>
  <h3>Full Name: &nbsp;<span class="not-bold">{{currentPatient?.firstName}} {{currentPatient?.lastName}}</span></h3>

  <form [formGroup]='form'>
    <mat-radio-group formControlName="patientClinic" class="background-text-element">
      @for (shop of shopList; track shop) {
        <mat-radio-button [value]="shop">{{[shop.shopId,shop.shopName,shop.addressLine1,shop.addressLine2].join(', ')}}</mat-radio-button>
      }

    </mat-radio-group>
  </form>

</mat-dialog-content>

<mat-dialog-actions>
  <span class="spacer"></span>
  <button mat-raised-button color="warn" [disabled]="isDisabledButton()"  (click)="onSubmit()">Confirm</button>
</mat-dialog-actions>

<ng-template #none>
  <mat-icon svgIcon='dash'></mat-icon>
</ng-template>